// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-width-box-form[data-v-b54cce90] {\n  max-width: 523px;\n}\n.form-data[data-v-b54cce90] {\n  margin-top: 40px;\n  background-color: #f9f9f9;\n  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));\n  border-radius: 21.4881px;\n}\n.buttonBack[data-v-b54cce90] {\n  font-weight: 500;\n  font-size: 18.3521px;\n  line-height: 27px;\n  opacity: 1;\n  background-color: #f4f4f4;\n  color: gray;\n  border: 2px solid gray;\n}", ""]);
// Exports
module.exports = exports;
